<template>
  <div class="block-form">
    <q-input
      outlined
      :model-value="block.language"
      label="Lenguaje (opcional, ej: javascript)"
      @update:model-value="emit('update', { ...block, language: String($event ?? '') })"
    />
    <q-input
      outlined
      type="textarea"
      :model-value="block.code"
      label="Código"
      rows="6"
      input-class="mono-input"
      @update:model-value="emit('update', { ...block, code: String($event ?? '') })"
    />
  </div>
</template>

<script setup lang="ts">
interface CodeBlock {
  type: 'code';
  language?: string;
  code: string;
}

const props = defineProps<{ block: CodeBlock }>();
const emit = defineEmits<{ (e: 'update', block: CodeBlock): void }>();

void props;
</script>

<style scoped lang="scss">
.block-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
:deep(.mono-input) {
  font-family: var(--oa-font-mono, 'JetBrains Mono', monospace);
  font-size: 13px;
}
</style>
